import { CustomerSearchResponse } from '@app/shared/models/customer-search-response.model';

export class ApiCustomerSearch {
  static readonly type = '[Api] Customer Search';
  constructor(public query: string) {}
}

export class ApiCustomerSearchSuccess {
  static readonly type = '[Api] Customer Search Success';
  constructor(public searchResponse: CustomerSearchResponse) {}
}

export class ApiCustomerSearchError {
  static readonly type = '[Api] Customer Search Error';
  constructor(public error: string) {}
}

export class ResetCustomerSearchAction {
  static readonly type = '[Customer search] Reset customer search';
}
